//get template url
window.get_tepmlate_url = function get_tepmlate_url(template, setup_url){
    var query_string = '#';
    var integration = getIntegrationByTemplateId(template.id);
    var integration_query_string = (integration !== null) ? '&integration_id=' + integration.id + '&bundle_instance_id=' + integration.bundle_instance : "";
    var template_copy = {};
    template_copy['product_info'] = (template['product_info'] === null) ? null : true;
    template_copy['name'] = template['name'];
    template_copy['id'] = template['id'];
    var template_query_string = "&template="  + btoa(JSON.stringify(template_copy));

    query_string = setup_url+'?template_id=' + template.id + integration_query_string + encodeURI(template_query_string);
    return query_string;
}

//get card url
window.get_card_url = function get_card_url(card, card_url){
    var query_string = '#';
    if(card.product_info && card.product_info.show_product_page) {
        query_string = card_url+"/" + card.product_info.name + "/" + card.app_id;
    } else if(card.product_info && card.product_info.action_url) {
        query_string = card.product_info.action_url;
    }
    return query_string;
}

